<template>
  <div class="stateCenterCom">
    <StatusList @getClickData="getClickData" :activeTree="activeTree" />
    <div class="pubilcChartsBox" id="dynamicalSystemStateId">
      <div class="detailsCharts ashComWrap">
        <div class="comTitle">
          <h4>{{ title == "实时状态" ? "实时功率" : title }}</h4>
          <div style="display: flex">
            <template v-if="title == '环境监测' || title == '实时状态'">
              <DateQuick @getDateData="getDateData" :key="key" />
            </template>
            <template v-else>
              <DateTypeChange @getDateData="getDateData" :key="key" />
            </template>
          </div>
        </div>
        <div class="comContentBox content">
          <template v-if="title !== '报警分析'">
            <div class="tabList">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                  v-for="(v, i) in tabsList"
                  :key="i"
                  :label="v.name"
                  :name="v.key"
                  >{{ v.name }}</el-tab-pane
                >
              </el-tabs>
            </div>
            <div class="chartsBox">
              <PublicEcharts
                id="'detailsCharts'"
                :chartsData="chartsData"
                :type="'lightLine'"
              />
            </div>
          </template>
          <template v-else>
            <div class="itemBox secondAshComWrap">
              <div class="comTitle">
                <h4>报警数量</h4>
              </div>
              <div class="comContentBox">
                <PublicEcharts
                  id="'number'"
                  :chartsData="numList"
                  :type="'lightSwitchable'"
                />
              </div>
            </div>
            <div class="itemBox secondAshComWrap">
              <div class="comTitle">
                <h4>处理分析</h4>
              </div>
              <div class="comContentBox">
                <PublicEcharts
                  :id="'funnelCharts'"
                  :chartsData="funnelList"
                  :type="'funnelCharts'"
                />
              </div>
            </div>
            <div class="itemBox secondAshComWrap">
              <div class="comTitle">
                <h4>报警类型</h4>
              </div>
              <div class="comContentBox">
                <PublicEcharts
                  :id="'type'"
                  :chartsData="typeList"
                  :type="'ringChart'"
                />
              </div>
            </div>
            <div class="itemBox secondAshComWrap">
              <div class="comTitle">
                <h4>报警等级</h4>
              </div>
              <div class="comContentBox">
                <PublicEcharts
                  :id="'grade'"
                  :chartsData="gradeList"
                  :type="'ringChart'"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="alarmBox" v-if="title == '报警分析'">
        <AlarmOrderTable
          style="margin-bottom: 12px"
          :type="'alarm'"
          :deviceType="'动力系统'"
        />
      </div>
      <div
        class="alarmBox ashComWrap"
        v-if="
          title == '实时状态' &&
          (activeTree.type == '项目' || this.activeTree.type == '区域资产')
        "
      >
        <div class="comTitle">
          <h4>实时状态</h4>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'operational1'"
            :chartsData="operationalList"
            :type="'pieChart'"
          />
        </div>
      </div>
      <div class="alarmBox ashComWrap" v-if="title == '运维分析'">
        <div class="devOpsHead">
          <el-tabs v-model="devOpsActiveName" @tab-click="devOpsHandleClick">
            <el-tab-pane
              :label="v.name + '记录'"
              v-for="v in devOpsList"
              :key="v.name"
              :name="v.name"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="devOpsContent">
          <TablePublicCom :activeName="devOpsActiveName" :system="'动力系统'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import {
  dateFtt,
  matchingAlarmLevel,
  matchingDynamicalState,
} from "@/assets/js/utils";
import StatusList from "@/components/zixitong/dynamicalSystem/StatusList.vue";
import DateQuick from "@/components/DatePicker/DateQuick.vue";
import DateTypeChange from "@/components/DatePicker/DateTypeChange.vue";
import PublicEcharts from "@/components/PublicEcharts.vue";
import AlarmOrderTable from "@/components/fenxizujian/AlarmOrderTable.vue";
import TablePublicCom from "@/components/DevOps/TablePublicCom.vue";
export default {
  props: {
    activeTree: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    StatusList,
    DateQuick,
    DateTypeChange,
    PublicEcharts,
    AlarmOrderTable,
    TablePublicCom,
  },
  data() {
    return {
      title: "",
      key: 0,
      tabsList: [],
      activeName: "",
      chartsData: {
        name: "实时功率",
        unit: "kw",
        xData: ["1月", "2月", "3月", "4月"],
        dataArr: [{ name: "实时功率", data: [30, 40, 22, 27] }],
      },
      operationalList: { dataArr: [] }, //实时状态
      // 报警相关
      gradeList: {
        dataArr: [],
      }, //报警等级
      typeList: {
        dataArr: [],
      }, //报警类型
      numList: {
        type: "bar",
        unit: "次",
        showChange: false,
        xData: [],
        dataArr: [{ name: "报警数量", data: [] }],
      }, //报警数量
      funnelList: [], //处理分析
      dateData: {},
      devOpsActiveName: "",
      devOpsList: [],
    };
  },
  watch: {
    activeTree: {
      handler(newvalue, oldvalue) {
        this.key += 1;
        setTimeout(() => {
          this.getTabsList();
        }, 10);
      },
      deep: true,
    },
  },
  methods: {
    getClickData(title) {
      if (title != this.title) {
        this.key += 1;
        this.title = title;
        this.getTabsList();
      }
    },
    getTabsList() {
      this.tabsList = [];
      this.activeName = "";
      document.getElementById("dynamicalSystemStateId").scrollTop = 0;
      if (this.title == "实时状态") {
        this.tabsList = [{ name: "实时功率", key: "实时功率" }];
      } else if (this.title == "能耗") {
        this.tabsList = [
          { name: "用电量", key: "ec" },
          { name: "发电量", key: "sc" },
          { name: "节电率", key: "sr" },
        ];
      } else if (this.title == "运转分析") {
        this.tabsList = [
          { name: "运行距离", key: "rd" },
          { name: "运行时长", key: "wt" },
          { name: "等待时长", key: "rn" },
        ];
      } else if (this.title == "运维分析") {
        this.tabsList = [
          { name: "工单", key: "workOrder" },
          { name: "巡检", key: "inspection" },
          { name: "保养", key: "maintenance" },
        ];
        this.devOpsList = [
          { name: "巡检" },
          { name: "工单" },
          { name: "告警" },
          { name: "保养" },
        ];
        this.devOpsActiveName = this.devOpsList[0].name;
      } else if (this.title == "环境监测") {
        this.getEnvironmentCard();
      }
      this.activeName = this.tabsList[0]?.key;
    },
    getDateData(data) {
      // console.log("日月年切换选择", data);
      this.dateData = data;
      setTimeout(() => {
        this.getFun();
      }, 15);
    },
    handleClick(tab, event) {
      this.getFun();
    },

    getFun() {
      this.chartsData.name = "";
      this.chartsData.unit = "";
      this.chartsData.xData = [];
      this.chartsData.dataArr = [];
      this.params = {
        entityId: this.activeTree.id,
        dataType: this.activeName,
        type: this.dateData.timeType,
        date: this.dateData.timeValue,
      };
      if (this.title == "实时状态") {
        if (
          this.activeTree.type == "项目" ||
          this.activeTree.type == "区域资产"
        ) {
          this.getRealState();
        }
        this.getRealTimeCharts();
      } else if (this.title == "能耗") {
        this.getECCharts();
      } else if (this.title == "运转分析") {
        this.getRunAnalysisCharts();
      } else if (this.title == "运维分析") {
        this.getDevOpsCharts();
      } else if (this.title == "报警分析") {
        this.getAlarmLevelCharts();
        this.getAlarmType();
        this.getAlarmHandle();
        this.getAlarmNum();
      } else if (this.title == "环境监测" && this.tabsList.length != 0) {
        this.getRealTimeCharts();
      }
    },

    // 实时功率/环境监测图表
    async getRealTimeCharts() {
      let params = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        entityId: this.activeTree.id,
        keyName: this.activeName,
        type: "DAY",
        date: this.dateData.timeValue,
      };
      if (this.title == "环境监测") {
        params = Object.assign({ modular: "环境监测" }, params);
      }

      let res = await api.DynamicalStateRealTimeCharts(params);
      if (res && res.data.code == 200) {
        this.handelDayCharts(res.data.data);
      }
    },
    // 实时状态
    async getRealState() {
      this.operationalList.dataArr = [];
      let res = await api.DynamicalOPERATIONAL({
        assetId: this.activeTree.id,
        deviceType: "直梯、扶梯、加速带",
      });
      if (res && res.data.code == 200) {
        let obj = { name: "run", value: 0 };
        res.data.data.map((v) => {
          if (v.name == 1 || v.name == 3 || v.name == 4 || v.name == 5) {
            obj.value += Number(v.value);
          }
        });
        let newArr = res.data.data
          .filter((v) => {
            return v.name != 1 && v.name != 3 && v.name != 4 && v.name != 5;
          })
          .concat([obj]);
        this.operationalList.dataArr = Array.from(newArr).map((v) => ({
          name: matchingDynamicalState(v.name),
          value: v.value,
        }));
      }
    },

    // 能耗
    async getECCharts() {
      let res = await api.DynamicalStateECCharts(this.params);
      if (res && res.data.code == 200) {
        this.handleCharts(res.data.data);
      }
    },
    // 运转分析
    async getRunAnalysisCharts() {
      let res = await api.DynamicalStateRunAnalysisCharts(this.params);
      if (res && res.data.code == 200) {
        this.handleCharts(res.data.data);
      }
    },
    // 运维分析
    async getDevOpsCharts() {
      let res = await api.DynamicalStateDevOpsCharts(this.params);
      if (res && res.data.code == 200) {
        this.handleCharts(res.data.data);
      }
    },
    handleCharts(data) {
      this.chartsData.name = data[0]?.value[0]?.name;
      this.chartsData.unit = data[0]?.unit ?? "";
      this.chartsData.dataArr = [{ name: this.chartsData.name, data: [] }];
      data.map((v) => {
        this.chartsData.xData.push(
          this.activeName == "DAY"
            ? dateFtt("hh:mm", new Date(v.ts))
            : this.activeName == "YEAR"
            ? dateFtt("yyyy-MM", new Date(v.ts))
            : this.activeName == "UNLIMITED"
            ? dateFtt("yyyy年", new Date(v.ts))
            : dateFtt("yyyy-MM-dd", new Date(v.ts))
        );
        this.chartsData.dataArr[0].data.push(v.value[0].value);
      });
    },
    handelDayCharts(data) {
      this.chartsData.name = data[0]?.value[0]?.name;
      this.chartsData.unit = data[0]?.unit ?? "";
      this.chartsData.dataArr = [{ name: this.chartsData.name, data: [] }];
      data.map((v) => {
        this.chartsData.xData.push(dateFtt("hh:mm", new Date(v.ts)));
        this.chartsData.dataArr[0].data.push(v.value[0].value);
      });
    },
    // 环境监测
    async getEnvironmentCard() {
      let res = await api.DynamicalStateEnvironment({
        entityId: this.activeTree.id,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        modular: "环境监测",
      });
      if (res && res.data.code == 200) {
        if (res.data.data.length != 0) {
          this.tabsList = Array.from(res.data.data[0]?.values).map((v) => ({
            name: v.name,
            key: v.name,
          }));
          this.activeName = this.tabsList[0]?.key;
          this.getFun();
        }
      }
    },

    // 报警分析
    async getAlarmLevelCharts() {
      this.gradeList.dataArr = [];
      let res = await api.DynamicalStateAlarmLevelCharts({
        entityId: this.activeTree.id,
        type: this.dateData.timeType,
        data: this.dateData.timeValue,
      });
      if (res && res.data.code == 200) {
        let arr = res.data.data.filter((v) => {
          return v.name == "CRITICAL" || v.name == "MAJOR" || v.name == "MINOR";
        });
        this.gradeList.dataArr = Array.from(arr).map((item) => ({
          name: matchingAlarmLevel(item.name),
          value: item.value,
        }));
      }
    },
    //报警类型
    async getAlarmType() {
      this.typeList.dataArr = [];
      let res = await api.DynamicalOverviewAlarmReason({
        entityId: this.activeTree.id,
        type: this.dateData.timeType,
        data: this.dateData.timeValue,
      });
      if (res && res.data.code == 200) {
        this.typeList.dataArr = res.data.data;
      }
    },
    // 报警-处理分析
    async getAlarmHandle() {
      this.funnelList = [
        // {
        //   value: 5000,
        //   name: "报警数量",
        //   proportion: 100,
        // },
      ];
      let res = await api.DynamicalStateAlarm({
        entityId: this.activeTree.id,
        type: this.dateData.timeType,
        data: this.dateData.timeValue,
      });
      if (res && res.data.code == 200) {
        this.funnelList = res.data.data;
      }
    },
    // 报警数量
    async getAlarmNum() {
      this.numList.xData = [];
      this.numList.dataArr[0].data = [];
      let res = await api.getSAlarmRangeTrend({
        type: this.dateData.timeType,
        data: this.dateData.timeValue,
        assetId: this.activeTree.id,
        assetType: "动力系统",
      });
      if (res && res.data.code == 200) {
        res.data.data.map((v) => {
          this.numList.xData.push(
            this.dateData.timeType == "DAY"
              ? dateFtt("dd日hh:mm", new Date(v.ts))
              : this.dateData.timeType == "YEAR"
              ? dateFtt("yyyy-MM", new Date(v.ts))
              : this.dateData.timeType == "UNLIMITED"
              ? dateFtt("yyyy年", new Date(v.ts))
              : dateFtt("yyyy-MM-dd", new Date(v.ts))
          );
          this.numList.dataArr[0].data.push(v.value);
        });
      }
    },
    // 运维分析
    devOpsHandleClick() {},
  },
};
</script>

<style lang="scss" scoped>
.stateCenterCom {
  width: 100%;
  height: 100%;
  .pubilcChartsBox {
    width: 100%;
    height: calc(100% - 260px);
    overflow: auto;
    .detailsCharts {
      width: 100%;
      height: 450px;
      .content {
        display: flex;
        flex-wrap: wrap;
        .tabList {
          width: 96%;
          height: 45px;
          margin: 0 auto;
        }
        .chartsBox {
          width: 100%;
          height: calc(100% - 45px);
        }
        .itemBox {
          width: 50%;
          height: 50%;
        }
      }
    }
    .alarmBox {
      width: 100%;
      height: 500px;
      margin-top: 12px;
      .devOpsHead {
        width: 96%;
        height: 48px;
        margin: 0 auto;
      }
      .devOpsContent {
        width: 100%;
        height: calc(100% - 48px);
      }
    }
  }
}
</style>
